import { render, staticRenderFns } from "./ordersOverviewItemTable.vue?vue&type=template&id=a808331e&"
import script from "./ordersOverviewItemTable.vue?vue&type=script&lang=ts&"
export * from "./ordersOverviewItemTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports